import {useEffect} from 'react';
import {usePrevious} from '../../../../../../common/shared/hooks/usePrevious';
import {SceneKey} from '../type/KeyType.type';
import {scrollToWindowBottommost} from '../util/scrollToWindowBottommost';
import {scrollToWindowTopmost} from '../util/scrollToWindowTopmost';

interface Props {
  sceneId: SceneKey;
  prevSceneId?: SceneKey;
  nextSceneId?: SceneKey;
  visitedTalkCount: number;
  calculateAndDispatchExposedArea: Function;
}

export function useScrollWhenSceneChange({
  sceneId,
  prevSceneId,
  nextSceneId,
  visitedTalkCount,
  calculateAndDispatchExposedArea,
}: Props) {
  const storedPrevSceneId = usePrevious(sceneId);
  const prevVisitedTalkCount = usePrevious(visitedTalkCount);
  /**
   * 어떠한 이유에 의해 씬만 변경되었을 경우(visitedTalkCount의 직접적인 변화 없이, 예를 들면 상/하단 pull 동작) 스크롤 처리
   * 스크롤 동작이 되면서 스크롤 핸들러에서 visitedTalkCount를 변경된 씬에 맞게 처리 해 준다.
   * 다만, 스크롤이 생길 정도로 씬이 길지 않은 경우 스크롤 핸들러가 발생되지 않기 때문에 이 때를 위해
   * visitedTalkCount를 계산하는 calculateAndDispatchExposedArea 함수를 별도로 한 번 더 호출 해 준다.
   * (해당 함수는 debounce로 wrapping 되어 있어서 중복 호출되어도 괜찮다)
   * visitedTalkCount이 변한 경우는 특정 톡을 대상으로 이동 한 경우이므로, 해당 톡으로 이동해야 해서 별도 로직에서 처리한다.
   */
  useEffect(() => {
    if (
      sceneId !== storedPrevSceneId &&
      prevVisitedTalkCount === visitedTalkCount
    ) {
      // 이전 신 이동시 최하단 스크롤
      if (nextSceneId === storedPrevSceneId) {
        scrollToWindowBottommost();
        calculateAndDispatchExposedArea();
      }
      // 다음 신 이동시 최상단 스크롤
      else if (prevSceneId === storedPrevSceneId) {
        scrollToWindowTopmost();
        calculateAndDispatchExposedArea();
      }
    }
  }, [
    sceneId,
    nextSceneId,
    storedPrevSceneId,
    prevSceneId,
    prevVisitedTalkCount,
    visitedTalkCount,
    calculateAndDispatchExposedArea,
  ]);
  return null;
}
